import { render } from "./LessonEdit.vue?vue&type=template&id=7645bc28"
import script from "./LessonEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/lesson/LessonEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7645bc28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7645bc28', __exports__)) {
    api.reload('7645bc28', __exports__)
  }
  
  module.hot.accept("./LessonEdit.vue?vue&type=template&id=7645bc28", () => {
    api.rerender('7645bc28', render)
  })

}


export default __exports__